import React from 'react';

import LegalPolicyPage from './LegalPolicyPage';

interface TrustCenterPageProps {
  onNavigate: (view: string) => void;
}

const TrustCenterPage: React.FC<TrustCenterPageProps> = ({ onNavigate }) => (
  <LegalPolicyPage policyId="trust" onNavigate={onNavigate} />
);

export default TrustCenterPage;
